import PhotoList from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ManageBlog from "../../../../../components/sections/admin/Blog/ManageBlog";
import ManagePhoto from "../../../../../components/sections/admin/Photo/ManagePhoto";
import PhotoCategory from "../PhotoCategory";
import PhotoComment from "../PhotoComment";
import PhotoTags from "../PhotoTags";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-blog",
    path: "/admin/photos",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/photo-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/photo-tags",
  },
  // {
  //   label: "Comments",
  //   icon: "fa-regular fa-comments",
  //   path: "/admin/photo-comments",
  // },
];

export const photoRoutes = () => [
  {
    path: "/admin/photos",
    component: () => (
      <TabsNavigation title="Photos Management" tabRoutes={tabRoutes}>
        <PhotoList />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Photos Management",
  },
  {
    path: "/admin/photo-categories",
    component: () => (
      <TabsNavigation title="Photos Management" tabRoutes={tabRoutes}>
        <PhotoCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Photos Management",
  },
  {
    path: "/admin/photo-tags",
    component: () => (
      <TabsNavigation title="Photos Management" tabRoutes={tabRoutes}>
        <PhotoTags />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Photos Management",
  },
  // {
  //   path: "/admin/photo-comments",
  //   component: () => (
  //     <TabsNavigation title="Photos Management" tabRoutes={tabRoutes}>
  //       <PhotoComment />
  //     </TabsNavigation>
  //   ),
  //   layout: "admin",
  //   routeType: "admin",
  //   title: "Photos Management",
  // },
  {
    path: "/admin/manage-photos",
    component: ManagePhoto,
    layout: "admin",
    routeType: "admin",
    title: "Manage Photos",
  },
  {
    path: `/admin/manage-photos/:id`,
    component: ManagePhoto,
    layout: "admin",
    routeType: "admin",
    title: "Manage Photos",
  },
];
